import { useEffect } from 'react'

export const useFoundation = (selector: string = 'document'): void => {
  useEffect(() => {
    const $el = selector === 'document' ? $(document) : $(selector)
    $el.foundation()

    return () => {
      try {
        $el.foundation('destroy')
      } catch (e) {
        console.error(e)
      }
    }
  }, [selector])
}
